class ConfigClass {}

export const Config = new ConfigClass();
